export default __webpack_public_path__ + "static/media/biat.caff6c35.png";